import React from "react";
import { Modal, Steps, Button, Space } from "antd";
import { useAddMarketForm } from "./hooks/useAddMarketForm";
import Step1 from "./steps/Step1";
import Step2 from "../CreateWorkspaceModal/steps/Step2";
import Step3 from "../CreateWorkspaceModal/steps/Step3";
import Step4 from "../CreateWorkspaceModal/steps/Step4";

const STEPS = [
  { title: "Market" },
  { title: "Weights" },
  { title: "Assignments" },
  { title: "Review" },
];

const AddMarketModal = ({ open, onCancel, onSuccess }) => {
  const form = useAddMarketForm(open, onSuccess);

  const renderStep = () => {
    switch (form.currentStep) {
      case 0:
        return <Step1 {...form} />;
      case 1:
        return <Step2 {...form} />;
      case 2:
        return <Step3 {...form} />;
      case 3:
        return <Step4 {...form} />;
      default:
        return null;
    }
  };

  return (
    <Modal
      title="Add Market to Existing Workspace"
      open={open}
      onCancel={onCancel}
      width={880}
      footer={null}
    >
      <div style={{ padding: "20px 0" }}>
        <Steps
          current={form.currentStep}
          items={STEPS}
          style={{ marginBottom: 24 }}
        />
        <div style={{ minHeight: 420 }}>{renderStep()}</div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 24,
            paddingTop: 16,
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <Button onClick={onCancel}>Cancel</Button>
          <Space>
            {form.currentStep > 0 && (
              <Button onClick={form.prev}>Previous</Button>
            )}
            <Button
              type="primary"
              onClick={form.next}
              loading={form.workspaceLoading}
              disabled={form.workspaceLoading}
            >
              {form.currentStep === STEPS.length - 1
                ? form.workspaceLoading
                  ? "Adding..."
                  : "Add Market"
                : "Next"}
            </Button>
          </Space>
        </div>
      </div>
    </Modal>
  );
};

export default AddMarketModal;
